export var CustomizeReportError;
(function (CustomizeReportError) {
})(CustomizeReportError || (CustomizeReportError = {}));
var CustomizeReportRequest = /** @class */ (function () {
    function CustomizeReportRequest(id, custom, reportSettings, query) {
        this.knownErrorCodes = Object.values(CustomizeReportError);
        this.method = custom ? 'put' : 'post';
        this.path = "".concat(custom ? 'my/customized-' : '', "reports/").concat(encodeURIComponent(id), "/rows/customize?").concat(String(query.searchParams));
        this.body = JSON.stringify(reportSettings);
    }
    return CustomizeReportRequest;
}());
export { CustomizeReportRequest };
